module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-asa.039e5f0b.png";